"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTokenAuthDeepLink = exports.isPasswordAuthDeepLink = void 0;
exports.isPasswordAuthDeepLink = function (link) {
    return typeof (link === null || link === void 0 ? void 0 : link.auth_username) === 'string' && typeof (link === null || link === void 0 ? void 0 : link.auth_password) === 'string';
};
exports.isTokenAuthDeepLink = function (link) {
    return typeof (link === null || link === void 0 ? void 0 : link.auth_username) === 'string' && typeof (link === null || link === void 0 ? void 0 : link.auth_token) === 'string';
};
